import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const PolygonIcon = React.memo(function PolygonIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 2.25L13.25 12.25H1.75L7.5 2.25Z"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
});
